export default __webpack_public_path__ + "static/media/vip-9.792159c0.svg";